import { render, staticRenderFns } from "./ProblemConfirmation.vue?vue&type=template&id=9b7ec41e&scoped=true"
import script from "./ProblemConfirmation.vue?vue&type=script&lang=js"
export * from "./ProblemConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ProblemConfirmation.vue?vue&type=style&index=0&id=9b7ec41e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7ec41e",
  null
  
)

export default component.exports